export { default } from './EmprestimoGarantiaCarroMaisLonge';
